<template>
  <header class="podcasts-archive__header">
    <div class="container">
      <div class="header__logo">
        <a href="/">
          <img src="/wp-content/themes/arkansasTheme/build/images/razorlogo_red.png" alt="Arkansasrazorbacks.com">
        </a>
      </div>
      <nav class="menu">
        <a href="#" class="hamb">
          <span></span><span></span><span></span>
          <strong class="sr-only">Open Mobile Menu</strong>
        </a>
        <ul>
          <li v-for="(link, index) in links" :key="index">
            <a :href="link.url"
               target="_blank"
               rel="nofollow"
               :class="{'btn': link.type === 'button'}">
              {{ link.label }}
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  data: () => ({
    links: []
  }),
  mounted() {
    const fields = this.$page?.fields || {}

    if(fields?.menu) {
      this.links = fields.menu
    }
  }
}
</script>
